export class SeverityFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "In",
            "type": "Array<Severity>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "NotIn",
            "type": "Array<Severity>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SeverityFilters.attributeTypeMap;
    }
    constructor() {
    }
}
